export default __webpack_public_path__ + "static/media/comfortaa-bold-webfont.273b3bcd.woff2";